import React from 'react';
import { translate } from 'react-i18next';
import styles from './brightnesstabs.scss';

const BrightnessTabs = ({ t, activeTab, brightness, onChange }) => {
  return (
    <ul className="tabs">
      {['Default', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => {
        let className = day.toLowerCase() === activeTab ? 'tab active' : 'tab';
        if(brightness[day.toLowerCase()] && brightness[day.toLowerCase()].length > 0) {
          className += ' has-content';
        }
        return (
          <li className={className} key={day}>
            <a href="#" onClick={() => onChange(day.toLowerCase())}>{t(day)}</a>
          </li>
        )
      })}
    </ul>
  )
}

BrightnessTabs.defaultProps = {
  activeTab: 'default'
}

export default translate('profile')(BrightnessTabs);



// WEBPACK FOOTER //
// ./src/components/profiles/BrightnessTabs.js